export const isValidHttpUrl = (value: string): boolean => {
  if (/\s/.test(value)) return false
  try {
    const url = new URL(value)

    return url.hostname.includes('.') && ['https:', 'http:'].includes(url.protocol)
  } catch {
    return false
  }
}

export const safeHttpUrl = (value: string | undefined | null): string => {
  const trimmed = (value ?? '').trim()

  return trimmed && isValidHttpUrl(trimmed) ? trimmed : ''
}

export const isInvalidUrlInput = (value: string | undefined | null): boolean => {
  const trimmed = (value ?? '').trim()

  return trimmed.length > 0 && !isValidHttpUrl(trimmed)
}
